module.exports = __webpack_public_path__ + "img/png.94f17ddf.png";